module.exports = __webpack_public_path__ + "media/audio16.65416c44.mp3";